/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var NameUtility = require("utils/NameUtility");

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var WidgetListAnchorView = require("personalization-web-agent-views/widget-views/widget-list/WidgetListAnchorView");
    var WidgetCollection = require("personalization-web-agent-collections/WidgetCollection");
    var WidgetModel = require("personalization-web-agent-models/WidgetModel");

    var IFrameIntegrationWidgetAnchorController={};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        IFrameIntegrationWidgetAnchorController = BaseFeatureController.extend({

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "IFrameIntegrationWidgetAnchorController:initialize");
                this.featuresToEdit = options.featureOptions.editController.FEATURES_TO_EDIT;
                this.channel = LEPersonalization.media.channel("IFrameIntegrationWidget");
                this.vent = this.channel.vent;
                this.channel.reset();

                this._createViews();
                this._bindEvents();
            },

            onClose: function () {
                LEPersonalization.logger.info("closing", "IFrameIntegrationWidgetAnchorController:onClose");
            },

            /************************** Public functions *****************************************************/
            getAnchorView:function(options){
                LEPersonalization.logger.info("getAnchorView", "IFrameIntegrationWidgetAnchorController:getAnchorView");
                options = $.extend(options , {
                    vent: this.vent,
                    widgetsCollection: this.widgetsCollection
                });

                return new WidgetListAnchorView(options);
            },

            getAnchorModel:function(){
                return new (Backbone.Model.extend({}))();
            },

            /************************** private functions *****************************************************/
            _createViews: function(){
                LEPersonalization.logger.info("creating views", "IFrameIntegrationWidgetAnchorController:_createViews");
                this.widgetsCollection = new WidgetCollection();
                this._fetchWidgetsCollection();
            },

            _fetchWidgetsCollection: function(){
                LEPersonalization.loader.setLoader();
                this.widgetsCollection.fetch({
                    success: (function (collection, response, options) {
                        LEPersonalization.loader.closeLoader();
                        this._createCoreWidgets(collection);
                    }).bind(this),
                    error: _.bind(function (collection, response, options) {
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.error("collection fetch error", "IFrameIntegrationWidgetAnchorController:_createViews", response);

                        LEPersonalization.notifier.showError({
                            content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.load.error"),
                            timeToShow: 6000
                        });

                        this._returnToVisitorPageMenu();
                    }, this)
                });
            },

            _createCoreWidgets: function(widgets) {
                var newWidgets = [],
                    widget,
                    mergedWidgets;

                mergedWidgets = LE.crossModule("webagent", LE.media.actions.request, LE.mediaCodes.webAgent.reqres.getWidgets);

                if(widgets.length > 0) {
                    for (var i = 0; i < mergedWidgets.length; i++) {
                        widget = widgets.findWhere({name: mergedWidgets[i].name});
                        if (!widget) {
                            delete mergedWidgets[i].isSupported;
                            newWidgets.push(mergedWidgets[i]);
                        }
                    }
                } else {
                    newWidgets = mergedWidgets;
                }
                this.widgetsCollection.createCoreWidgets(newWidgets);
            },

            _bindEvents:function(){
                LEPersonalization.logger.info("binding events", "IFrameIntegrationWidgetAnchorController:_bindEvents");

                this.listenTo(this.vent, "widget:edit", this._onWidgetEditClick);
                this.listenTo(this.vent, "widget:organize", this._onOrganizeEditClick);
                this.listenTo(this.vent, "widget:remove", this._onWidgetRemoveClick);
                this.listenTo(this.vent, "widget:pilot", this._onWidgetPilotChange);
                this.listenTo(this.vent, "widget:hide", this._onWidgetHideChange);
                this.listenTo(this.vent, "widget:add", this._onAddWidgetClick);
            },

            _onWidgetEditClick: function(options){
                var editedModel = new WidgetModel({id: options.model.id});
                LEPersonalization.loader.setLoader();

                editedModel.fetch({
                    success: _.bind(function (model, response, options) {
                        LEPersonalization.logger.info("model fetch success", "IFrameIntegrationWidgetAnchorController:_onWidgetEditClick");
                        LEPersonalization.navigateToFeatureEdit({
                            featureId: "IFrameIntegration",
                            controllerOptions: {
                                editedModel: model,
                                vent: this.vent,
                                collection: this.widgetsCollection,
                                controllerOptions: {
                                    featureToEdit: this.featuresToEdit.EDIT_WIDGET
                                }
                            }
                        });
                        LEPersonalization.loader.closeLoader();
                    }, this),
                    error: _.bind(function (model, response, options) {
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.error("model fetch error", "IFrameIntegrationWidgetAnchorController:_onWidgetEditClick", response);

                        LEPersonalization.notifier.showError({
                            content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.errors.default.fetch"),
                            timeToShow: 6000
                        });

                        this._fetchWidgetsCollection();
                    }, this)
                });
            },

            _onOrganizeEditClick: function () {
                LEPersonalization.navigateToFeatureEdit({
                    featureId: "IFrameIntegration",
                    controllerOptions: {
                        vent: this.vent,
                        collection: this.widgetsCollection,
                        controllerOptions: {
                            featureToEdit: this.featuresToEdit.ORGANIZE_WIDGETS
                        }
                    }
                });
            },

            _onWidgetRemoveClick: function(options){
                LEPersonalization.notifier.showConfirm({
                    title: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.remove.confirmation.title"),
                    content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.remove.confirmation.text"),
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.yes"),
                        callback: _.bind(this._deleteWidget, this, options.model)
                    }
                });
            },

            _onWidgetPilotChange: function(options){
                if(!options.state){ //user clicked to remove pilot mode
                    LEPersonalization.notifier.showConfirm({
                        title: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.removePilot.confirmation.title"),
                        content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.removePilot.confirmation.text"),
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.yes"),
                            callback: _.bind(this._updateWidgetPilotMode, this, {model: options.model, state: options.state})
                        }
                    });
                }
                else{
                    this._updateWidgetPilotMode(options);
                }
            },

            _updateWidgetPilotMode: function(options){
                var modelToSave = options.model.clone();
                modelToSave.setRevision(options.model.getRevision(true));
                modelToSave.togglePilotMode(options.state);

                this._save(modelToSave);
            },

            _onWidgetHideChange: function(options){
                if(!options.state){ //user clicked to unhide the widget
                    LEPersonalization.notifier.showConfirm({
                        title: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.unhide.confirmation.title"),
                        content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.unhide.confirmation.text"),
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.yes"),
                            callback: _.bind(this._updateWidgetHide, this, {model: options.model, state: options.state})
                        }
                    });
                }
                else{
                    this._updateWidgetHide(options);
                }
            },

            _updateWidgetHide: function(options){
                var modelToSave = options.model.clone();
                modelToSave.setRevision(options.model.getRevision(true));
                modelToSave.setEnabled(!options.state);

                this._save(modelToSave);
            },

            _onAddWidgetClick: function() {
                LEPersonalization.navigateToFeatureEdit({
                    featureId: "IFrameIntegration",
                    controllerOptions: {
                        editedModel: new WidgetModel({name: NameUtility.getUniqueName(this.widgetsCollection, LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions.addWidget.default.name"))}),
                        vent: this.vent,
                        collection: this.widgetsCollection,
                        controllerOptions: {
                            featureToEdit: this.featuresToEdit.EDIT_WIDGET
                        }
                    }
                });
            },

            _save: function(modelToSave){
                LEPersonalization.loader.setLoader();

                modelToSave.save(null, {
                    success: _.bind(function (model, response, options) {
                        LEPersonalization.logger.info("model edit save success", "IFrameIntegrationWidgetAnchorController:_save");
                        var updatedModel = this.widgetsCollection.add(model, {merge: true});
                        updatedModel.setRevision(model.getRevision(true));
                        LEPersonalization.loader.closeLoader();

                    }, this),
                    error: function (model, response, options) {
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.error("model edit save error", "IFrameIntegrationWidgetAnchorController:_save", response);

                        if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                            LEPersonalization.notifier.showError({
                                content: response.responseError.message,
                                timeToShow: 6000
                            });
                        }
                        else{
                            LEPersonalization.notifier.showError({
                                content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.errors.default.save"),
                                timeToShow: 6000
                            });
                        }
                    }
                });
            },

            /************************** Utility private functions that does not need "this" ********************/
            _deleteWidget: function(widgetModel){
                LEPersonalization.loader.setLoader();

                widgetModel.destroy({
                    success: _.bind(function(model, response) {
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.info("model delete success", "IFrameIntegrationWidgetAnchorController:_deleteWidget");
                        //Since there's a meaning to the order of the widgets in the collection(BE), in certain scenarios we cannot delete widgets with incorrect revision
                        this._fetchWidgetsCollection();
                    },this),
                    error: function(model, response){
                        LEPersonalization.loader.closeLoader();
                        LEPersonalization.logger.error("model delete error", "IFrameIntegrationWidgetAnchorController:_deleteWidget", response);

                        if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                            LEPersonalization.notifier.showError({
                                content: response.responseError.message,
                                timeToShow: 6000
                            });
                        }
                        else{
                            LEPersonalization.notifier.showError({
                                content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.errors.default.delete"),
                                timeToShow: 6000
                            });
                        }
                    },
                    wait: true
                });
            },

            _returnToVisitorPageMenu:function(){
                LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.hideSimulatedEngagement);
                LEPersonalization.navigateToPageMenu({
                    module:"LEWebAgent", //todo use Const
                    page:"VisitorListTableViewController" // Todo elina Adif to have list of pages some where
                });
            }
        });
    });
    return IFrameIntegrationWidgetAnchorController;
});
